












import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { ShoppingCart } from '@/entities/ShoppingCart';
import { SaveIcon } from '@/components/icons/SaveIcon';

@Component({
    components: {
        SaveIcon,
    },
})
export default class ShoppingCartItemUserInfoText extends Vue {
    @Prop(String)
    private userInfoText!: string;

    private currentUserInfoText: string = this.userInfoText;

    private get showSaveButton(): boolean {
        return this.userInfoText !== this.currentUserInfoText;
    }

    @Watch('userInfoText')
    private userInfoTextChanged(text: string): void {
        this.currentUserInfoText = text;
    }

    @Emit('save')
    private save(): string {
        return this.currentUserInfoText;
    }
}
